import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Time Frame
//Fetch Time Frame data
export const fetchTimeFrameData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(
      `rackstar/timeframe?noCache=${noCache}`
    );
    return getSuccessRes(
      res.data || [],
      "Time Frame data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Time Frame data.`);
  }
};

//Delete Time Frame
export const deleteTimeFrameData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/timeframe/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Time Frame data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Time Frame data.`);
  }
};

// Update an existing Time Frame entry
export const updateTimeFrameData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/timeframe/${id}`,
      data
    );
    return getSuccessRes(res.data, "Time Frame data updated successfully!");
  } catch (error) {
    logger.error("updateTimeFrameData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Time Frame Data.");
  }
};

//Add a Time Frame data
export const addTimeFrameData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/timeframe`,
      data
    );
    return getSuccessRes(res.data, "Time Frame data added successfully!");
  } catch (error) {
    logger.error("addTimeFrameData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Time Frame data.");
  }
};

//Time Zone
//Fetch Time Zone data
export const fetchTimeZoneData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(
      `rackstar/timezone?noCache=${noCache}`
    );
    return getSuccessRes(
      res.data || [],
      "Time Zone data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Time Zone data.`);
  }
};

//Delete Time Zone
export const deleteTimeZoneData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/timezone/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Time Zone data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Time Zone data.`);
  }
};

// Update an existing Time Zone entry
export const updateTimeZoneData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/timezone/${id}`,
      data
    );
    return getSuccessRes(res.data, "Time Zone data updated successfully!");
  } catch (error) {
    logger.error("updateTimeZoneData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Time Zone Data.");
  }
};

//Add a Time Zone data
export const addTimeZoneData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/timezone`,
      data
    );
    return getSuccessRes(res.data, "Time Zone data added successfully!");
  } catch (error) {
    logger.error("addTimeZoneData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Time Zone data.");
  }
};